import controllers from "venuescanner-js/services/controllers";

export const getSession = async (sessionId) => {
  const response = await controllers.stripe.getSession.get({ sessionId });
  const {
    data: { session },
  } = response;

  return session;
};
